import {
    Abc,
    AccessTimeOutlined,
    AccountCircleOutlined,
    AccountTree,
    AccountTreeOutlined,
    Add,
    AddCard,
    AddCircleOutline,
    AddOutlined,
    AdminPanelSettingsOutlined,
    AnalyticsOutlined,
    Approval,
    AppsOutlined,
    ArrowBackOutlined,
    ArrowDownwardOutlined,
    ArrowDropDownOutlined,
    ArrowDropUpOutlined,
    ArrowForwardOutlined,
    ArrowUpwardOutlined,
    ArticleOutlined,
    Assessment,
    AssignmentOutlined,
    AttachFile,
    AttachFileOutlined,
    AttachMoney,
    AudioFileOutlined,
    AutoAwesomeOutlined,
    AutoFixHigh,
    AutorenewOutlined,
    BarChart,
    BookOnline,
    BrokenImageOutlined,
    BuildCircleOutlined,
    BusinessOutlined,
    Cached,
    Calculate,
    CalendarMonth,
    CalendarToday,
    CalendarViewWeekOutlined,
    CameraAlt,
    CancelOutlined,
    CancelScheduleSend,
    CategoryOutlined,
    CenterFocusStrongOutlined,
    ChangeHistoryOutlined,
    Check,
    CheckBoxOutlineBlank,
    CheckBoxOutlined,
    CheckCircleOutline,
    CheckOutlined,
    Checklist,
    Checkroom,
    ChevronLeft,
    ChevronRight,
    CircleOutlined,
    Clear,
    ClearAllOutlined,
    CloseOutlined,
    CloudDoneOutlined,
    CloudOutlined,
    CollectionsBookmarkOutlined,
    ConfirmationNumber,
    ContactPageOutlined,
    ContentCopyOutlined,
    CropOutlined,
    CropSquareOutlined,
    DarkModeOutlined,
    DashboardOutlined,
    DeleteOutline,
    DescriptionOutlined,
    DeviceHub,
    DirectionsCar,
    Diversity3,
    Done,
    Download,
    DragIndicator,
    Edit,
    EditAttributes,
    EditNote,
    EditOutlined,
    EmailOutlined,
    Error,
    EventAvailable,
    EventAvailableOutlined,
    ExpandLessOutlined,
    ExpandMoreOutlined,
    FeedbackOutlined,
    FileDownloadOutlined,
    FileUploadOutlined,
    FilterAltOutlined,
    FolderOutlined,
    FolderZipOutlined,
    FormatAlignCenter,
    FormatAlignJustify,
    FormatAlignJustifyOutlined,
    FormatAlignLeft,
    FormatAlignRight,
    FormatBold,
    FormatColorText,
    FormatItalic,
    FormatListBulleted,
    FormatListBulletedOutlined,
    FormatListNumbered,
    FormatStrikethrough,
    FormatUnderlined,
    Functions,
    GTranslate,
    Grid3x3Outlined,
    GroupAddOutlined,
    HelpOutlineOutlined,
    HideImage,
    HomeOutlined,
    HomeRepairService,
    Image,
    Info,
    InfoOutlined,
    Inventory2,
    Inventory2Outlined,
    InventoryOutlined,
    KeyboardArrowDown,
    KeyboardOutlined,
    LabelOutlined,
    LanguageOutlined,
    Launch,
    LightModeOutlined,
    Link,
    LinkOutlined,
    LocalPhone,
    LocalPhoneOutlined,
    LocationOn,
    LocationOnOutlined,
    LockOpen,
    LockOutlined,
    LogoutOutlined,
    LoopOutlined,
    ManageAccountsOutlined,
    MapsHomeWorkOutlined,
    MenuOutlined,
    MoreVertOutlined,
    MovieCreation,
    NewspaperOutlined,
    NoteAdd,
    NoteAddOutlined,
    NoteAltOutlined,
    NotesOutlined,
    OpenInNew,
    OpenInNewOutlined,
    OpenWith,
    Password,
    PeopleOutlineOutlined,
    PersonOutline,
    PetsOutlined,
    PictureAsPdfOutlined,
    PivotTableChart,
    Place,
    PublicOutlined,
    QuestionMark,
    Recommend,
    Redo,
    Refresh,
    Remove,
    ReportOutlined,
    ReportProblemOutlined,
    RsvpOutlined,
    SaveOutlined,
    ScienceOutlined,
    SearchOutlined,
    SecurityOutlined,
    SellOutlined,
    Send,
    SettingsApplications,
    SettingsApplicationsOutlined,
    SettingsInputComponent,
    SettingsOutlined,
    ShareOutlined,
    ShopTwo,
    ShoppingBasketOutlined,
    SortByAlphaOutlined,
    SortOutlined,
    SpaceDashboardOutlined,
    Square,
    Star,
    StarOutline,
    StoreOutlined,
    Subscript,
    Summarize,
    SummarizeOutlined,
    Superscript,
    SupportAgent,
    SvgIconComponent,
    TableChartOutlined,
    TaskAlt,
    TerminalOutlined,
    TheaterComedy,
    ThumbDownAltOutlined,
    Title,
    TrendingDownOutlined,
    TrendingUpOutlined,
    TuneOutlined,
    Undo,
    UnfoldLessOutlined,
    UnfoldMoreOutlined,
    VideocamOutlined,
    ViewColumnOutlined,
    ViewColumnRounded,
    ViewTimeline,
    ViewWeekOutlined,
    Visibility,
    VisibilityOff,
    WidgetsOutlined,
    Workspaces,
    WorkspacesOutlined
} from '@mui/icons-material';
import { AaIcon } from './AaIcon';
import { AddContact } from './AddContact';
import { AttributeIcon } from './AttributeIcon';
import { AutoAwesomeGradient } from './AutoAwesomeGradient';
import { BackButton } from './BackButton';
import { Booking } from './Booking';
import { BulkLineItemIcon } from './BulkLineItemIcon';
import { BusinessContact } from './BusinessContact';
import { CapitalizeIcon } from './CapitalizeIcon';
import { CardList } from './CardList';
import { CardListPreview } from './CardListPreview';
import { Cast } from './Cast';
import { ComedyMask } from './ComedyMask';
import { CreativeWork } from './CreativeWork';
import { Deals } from './Deals';
import { Details } from './Details';
import { DigitalAssets } from './DigitalAssets';
import { DirectoryShowrunnrFilter } from './DirectoryShowrunnrFilter';
import { ExpandIcon } from './ExpandIcon';
import { GoogleLogo } from './GoogleLogo';
import { AddProductionImage } from './IconImages/AddProductionImage';
import { AddShortlistIcon } from './IconImages/AddShortlistIcon';
import { IMDb } from './IMDb';
import { ImportFile } from './ImportFile';
import { InquiryIcon } from './InquiryIcon';
import { KeyCreditIcon } from './KeyCreditIcon';
import { LinkedIn } from './LinkedIn';
import { LowercaseIcon } from './LowercaseIcon';
import { MicrosoftLogo } from './MicrosoftLogo';
import { MoveBooking } from './MoveBooking';
import { AddNote } from './NoteAdd';
import { Order } from './Order';
import { PlaceIcon } from './PlaceIcon';
import { PrimaryContactEmail } from './PrimaryContactEmail';
import { PrimaryContactPhone } from './PrimaryContactPhone';
import { Production } from './Production';
import { Quote } from './Quote';
import { RankOrder } from './RankOrder';
import { RequestAvailability } from './RequestAvailability';
import { RequestSent } from './RequestSent';
import { ResponseReceived } from './ResponseReceived';
import { ResumeAdd } from './ResumeAdd';
import { ResumeIcon } from './ResumeIcon';
import { RotateSchedule } from './RotateSchedule';
import { Scenarios } from './Scenarios';
import { SchedulerCalendar } from './SchedulerCalendar';
import { Service } from './Service';
import { ShowrunnrLogoMark } from './ShowrunnrLogoMark';
import { ShrinkIcon } from './ShrinkIcon';
import { SubmissionsPipeline } from './SubmissionsPipeline';
import { Success } from './Success';
import { Unlock } from './Unlock';
import { WatchIcon } from './WatchIcon';
import { WorkspacesOutlinedCustom } from './WorkspacesOutlinedCustom';

type IconsType = {
    [key in string]: SvgIconComponent;
};

export const Icons: IconsType = {
    Abc: Abc,
    AccessTime: AccessTimeOutlined,
    Account: SettingsOutlined,
    AccountCircle: AccountCircleOutlined,
    AccountTree: AccountTreeOutlined,
    AddButton: Add,
    AddCard: AddCard,
    AddCircle: AddCircleOutline,
    AddGroupOfPeople: GroupAddOutlined,
    AddOutlined: AddOutlined,
    AllColumns: CalendarViewWeekOutlined,
    Animal: PetsOutlined,
    ApplicationsSettings: SettingsApplications,
    Approval: Approval,
    ApprovalRequestSent: Send,
    ApprovalRequestCancelled: CancelScheduleSend,
    ApprovalRequestInitiateFailed: ReportOutlined,
    ApprovalRequestApproved: TaskAlt,
    ApprovalRequestRejected: ThumbDownAltOutlined,
    AppsOutlined: AppsOutlined,
    ArrowBack: ArrowBackOutlined,
    ArrowDownward: ArrowDownwardOutlined,
    ArrowDropDownOutlined: ArrowDropDownOutlined,
    ArrowForward: ArrowForwardOutlined,
    ArrowUpward: ArrowUpwardOutlined,
    Assignment: AssignmentOutlined,
    AttachFileOutlined: AttachFileOutlined,
    Attachments: AttachFile,
    Attributes: EditAttributes,
    AudioFile: AudioFileOutlined,
    BackButton: BackButton,
    Bookings: Booking,
    BookOnline: BookOnline,
    BuildCircleOutlined: BuildCircleOutlined,
    BulletedList: FormatListBulleted,
    Business: BusinessOutlined,
    CardListIcon: CardList,
    CardListPreview: CardListPreview,
    Cache: Cached,
    Calculate: Calculate,
    Calendar: CalendarToday,
    CalendarMonth: CalendarMonth,
    CropSquareOutlined: CropSquareOutlined,
    CameraAlt: CameraAlt,
    Cancel: CancelOutlined,
    Cast: Cast,
    Catalog: Inventory2Outlined,
    CatalogPrev: Inventory2,
    Category: CategoryOutlined,
    Check: CheckOutlined,
    Checkbox: CheckBoxOutlined,
    CheckboxBlank: CheckBoxOutlineBlank,
    CheckCircle: CheckCircleOutline,
    CheckIcon: Check,
    Checklist: Checklist,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    ClearAll: ClearAllOutlined,
    ClearIcon: Clear,
    Close: CloseOutlined,
    CollectionBookmarks: CollectionsBookmarkOutlined,
    ConfirmationNumber: ConfirmationNumber,
    ContactPage: ContactPageOutlined,
    ContentCopy: ContentCopyOutlined,
    Crew: SupportAgent,
    Crop: CropOutlined,
    CircleOutlined: CircleOutlined,
    ComedyMask: ComedyMask,
    Configuration: SettingsOutlined,
    ChangeHistoryOutlined: ChangeHistoryOutlined,
    DarkMode: DarkModeOutlined,
    Default: QuestionMark,
    DefaultColumns: Recommend,
    Deals: Deals,
    Delete: DeleteOutline,
    Details: Details,
    Demo: ShopTwo,
    DeviceHub: DeviceHub,
    Directory: SortByAlphaOutlined,
    Document: ArticleOutlined,
    Done: Done,
    Download: Download,
    Edit: Edit,
    EditOutlined: EditOutlined,
    Email: EmailOutlined,
    Equipement: VideocamOutlined,
    ErrorIcon: Error,
    EventAvailable: EventAvailable,
    ExpandLess: ExpandLessOutlined,
    ExpandIcon: ExpandIcon,
    ExpandMore: ExpandMoreOutlined,
    Facilities: MapsHomeWorkOutlined,
    Facility: MapsHomeWorkOutlined,
    Feedback: FeedbackOutlined,
    FileDownload: FileDownloadOutlined,
    FileUpload: FileUploadOutlined,
    Filters: FilterAltOutlined,
    Folder: FolderOutlined,
    FormatAlignCenter: FormatAlignCenter,
    FormatAlignJustify: FormatAlignJustify,
    FormatAlignLeft: FormatAlignLeft,
    FormatAlignRight: FormatAlignRight,
    FormatBold: FormatBold,
    FormatColorText: FormatColorText,
    FormatItalic: FormatItalic,
    FormatListNumbered: FormatListNumbered,
    FormatStrikethrough: FormatStrikethrough,
    FormatUnderline: FormatUnderlined,
    Forms: FormatAlignJustifyOutlined,
    Grid: Grid3x3Outlined,
    GridGrouping: AccountTree,
    Help: HelpOutlineOutlined,
    HideImage: HideImage,
    Home: HomeOutlined,
    Image: Image,
    InfoIcon: Info,
    InquiryIcon: InquiryIcon,
    KeyboardArrowDown: KeyboardArrowDown,
    Lab: ScienceOutlined,
    LabelOutlined: LabelOutlined,
    Language: LanguageOutlined,
    Launch: Launch,
    Leads: CenterFocusStrongOutlined,
    LightMode: LightModeOutlined,
    ListViewGallery: SpaceDashboardOutlined,
    ListViewList: FormatListBulletedOutlined,
    ListViewTable: ViewColumnOutlined,
    Location: LocationOn,
    LocationOutlined: LocationOnOutlined,
    Lock: LockOutlined,
    LockOpen: LockOpen,
    Logout: LogoutOutlined,
    Loop: LoopOutlined,
    NewTabIcon: OpenInNew,
    ManageAccounts: ManageAccountsOutlined,
    Marketplace: StoreOutlined,
    Menu: MenuOutlined,
    Money: AttachMoney,
    MongoReportComponent: DashboardOutlined,
    MoreVert: MoreVertOutlined,
    MovieCreation: MovieCreation,
    DocumentAdd: NoteAdd,
    DocumentAddOutlined: NoteAddOutlined,
    Notes: NotesOutlined,
    NotesOutlined: NoteAltOutlined,
    NoteAdd: AddNote,
    OpenInNew: OpenInNewOutlined,
    OpenWith: OpenWith,
    Order: Order,
    Organization: BusinessOutlined,
    Password: Password,
    PdfFile: PictureAsPdfOutlined,
    People: PeopleOutlineOutlined,
    PersonOutline: PersonOutline,
    Phone: LocalPhone,
    PhoneOutlined: LocalPhoneOutlined,
    PivotTableChart: PivotTableChart,
    Place: PublicOutlined,
    PlaceIcon: Place,
    Presets: SettingsApplicationsOutlined,
    Preview: Visibility,
    Product: ShoppingBasketOutlined,
    Production: Production,
    OutlinedPlaceIcon: PlaceIcon,
    Pending: AccessTimeOutlined,
    Products: ShoppingBasketOutlined,
    Profile: ManageAccountsOutlined,
    Prop: AutoFixHigh,
    Quote: Quote,
    Rate: SellOutlined,
    Redo: Redo,
    Refresh: Refresh,
    Report: BarChart,
    RequestAvailability: RequestAvailability,
    RequestSent: RequestSent,
    ResponseRecieved: ResponseReceived,
    RotateSchedule: RotateSchedule,
    TestReport: Assessment,
    ResourceFields: WidgetsOutlined,
    RichText: FormatColorText,
    Rsvp: RsvpOutlined,
    Save: SaveOutlined,
    Schedule: EventAvailableOutlined,
    SchedulerPreview: ViewTimeline,
    Science: ScienceOutlined,
    Search: SearchOutlined,
    Security: SecurityOutlined,
    Services: Service,
    ShrinkIcon: ShrinkIcon,
    Success: Success,
    Settings: AdminPanelSettingsOutlined,
    Share: ShareOutlined,
    Shortlist: FormatListBulleted,
    Sort: SortOutlined,
    ShowrunnrMark: ShowrunnrLogoMark,
    ShowrunnrFilter: DirectoryShowrunnrFilter,
    SquareIcon: Square,
    Star: Star,
    StarOutline: StarOutline,
    Store: StoreOutlined,
    Summary: Summarize,
    Templates: NewspaperOutlined,
    Terminal: TerminalOutlined,
    TheaterComedy: TheaterComedy,
    Tune: TuneOutlined,
    Undo: Undo,
    UnfoldLess: UnfoldLessOutlined,
    UnfoldMore: UnfoldMoreOutlined,
    Vehicle: DirectionsCar,
    Visibility: Visibility,
    VisibilityOff: VisibilityOff,
    WardrobeIcon: Checkroom,
    Workshop: HomeRepairService,
    Workspaces: Workspaces,
    SubmissionsPipeline: SubmissionsPipeline,
    WorkspacesOutlined: WorkspacesOutlined,
    WorkspacesOutlinedCustom: WorkspacesOutlinedCustom,
    ZipFolder: FolderZipOutlined,
    Info: InfoOutlined,
    BrokenImage: BrokenImageOutlined,
    DigitalAssets: DigitalAssets,
    CreativeWork: CreativeWork,
    LinkedIn: LinkedIn,
    IMDb: IMDb,
    GoogleLogo: GoogleLogo,
    MicrosoftLogo: MicrosoftLogo,
    ImportFile: ImportFile,
    Link: LinkOutlined,
    ArrowDropUp: ArrowDropUpOutlined,
    AddContact: AddContact,
    BusinessContact: BusinessContact,
    PrimaryContactEmail: PrimaryContactEmail,
    PrimaryContactPhone: PrimaryContactPhone,
    ResumeAdd: ResumeAdd,
    AutoAwesome: AutoAwesomeOutlined,
    ResumeIcon: ResumeIcon,
    AutoAwesomeGradient: AutoAwesomeGradient,
    EditPreview: EditNote,
    SummarizeOutlined: SummarizeOutlined,
    Scenarios: Scenarios,
    Keyboard: KeyboardOutlined,
    KeyCredit: KeyCreditIcon,
    MoveBooking: MoveBooking,
    AddProductionIcon: AddProductionImage,
    SchedulerCalendar: SchedulerCalendar,
    Analytics: AnalyticsOutlined,
    Columns: ViewColumnRounded,
    AddShortlistIcon: AddShortlistIcon,
    ReportProblemOutlined: ReportProblemOutlined,
    AttributeIcon: AttributeIcon,
    Subscript: Subscript,
    Superscript: Superscript,
    AaIcon: AaIcon,
    CapitalizeIcon: CapitalizeIcon,
    LowercaseIcon: LowercaseIcon,
    LinkIcon: Link,
    ColumnIcon: ViewWeekOutlined,
    TableIcon: TableChartOutlined,
    FontTitle: Title,
    RemoveButton: Remove,
    DragIndicator: DragIndicator,
    Unlock: Unlock,
    BulkLineItemIcon: BulkLineItemIcon,
    RankOrder: RankOrder,
    DescriptionOutlined: DescriptionOutlined,
    AutorenewOutlined: AutorenewOutlined,
    GTranslate: GTranslate,
    Corporate: Diversity3,
    InventoryOutlined: InventoryOutlined,
    Watch: WatchIcon,
    BusinessTransaction: SettingsInputComponent,
    TrendingDown: TrendingDownOutlined,
    TrendingUp: TrendingUpOutlined,
    CloudDone: CloudDoneOutlined,
    Cloud: CloudOutlined,
    Functions: Functions
};
